import React from 'react';
import { IconButton, Box, Tooltip, makeStyles, createStyles, Theme } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import FileCopyIcon from '@material-ui/icons/FileCopy';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    actionsContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.5),
    },
    actionButton: {
      padding: 4,
    },
  }),
);

interface ItemActionsProps {
  onDuplicate?: () => void;
  onDelete?: () => void;
  disabled?: boolean;
  size?: 'small' | 'medium';
}

/**
 * Shared component for item action buttons (duplicate, delete)
 * Used across ListEditor and MapEditor for consistent CRUD operations
 */
export const ItemActions: React.FC<ItemActionsProps> = ({
  onDuplicate,
  onDelete,
  disabled,
  size = 'small',
}) => {
  const classes = useStyles();

  if (disabled) {
    return null;
  }

  return (
    <Box className={classes.actionsContainer}>
      {onDuplicate && (
        <Tooltip title="Duplicate">
          <IconButton
            size={size}
            onClick={e => {
              e.stopPropagation();
              onDuplicate();
            }}
            className={classes.actionButton}
          >
            <FileCopyIcon fontSize={size} />
          </IconButton>
        </Tooltip>
      )}
      {onDelete && (
        <Tooltip title="Delete">
          <IconButton
            size={size}
            onClick={e => {
              e.stopPropagation();
              onDelete();
            }}
            className={classes.actionButton}
          >
            <DeleteIcon fontSize={size} />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};
